var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForward5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.342.198l6.042.416-2.467 5.602L7.428 3.71c-3.21 1.631-5.341 4.909-5.341 8.6C2.087 17.667 6.529 22 12 22c5.47 0 9.913-4.334 9.913-9.69 0-3.693-2.132-7.011-5.44-8.649-.454-.224-.925-.415-1.41-.568-.547-.174-.843-.74-.662-1.264.181-.524.771-.808 1.318-.635.589.187 1.16.418 1.711.69C21.429 3.864 24 7.865 24 12.311 24 18.763 18.632 24 12 24S0 18.763 0 12.31C0 7.889 2.544 3.954 6.396 1.97L5.342.199zm9.43 7.97v1.164h-3.276l-.204 2.268c.372-.192.732-.312 1.212-.312 1.476 0 2.688.876 2.688 2.808 0 1.956-1.428 3.06-2.976 3.06-1.392 0-2.268-.564-2.892-1.176l.66-.9c.504.504 1.14.948 2.064.948.996 0 1.752-.708 1.752-1.884s-.672-1.848-1.68-1.848c-.564 0-.9.168-1.416.504l-.672-.444.264-4.188h4.476z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward5);
export default __webpack_public_path__ + "static/media/forward-5.2b2ea09a.svg";
export { ForwardRef as ReactComponent };